// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyD8A1X0D6Lolk4zwp3fBgN710oNAaoIXBQ',
    authDomain: 'quibbl-35bd2.firebaseapp.com',
    databaseURL: 'https://quibbl-35bd2.firebaseio.com',
    projectId: 'quibbl-35bd2',
    storageBucket: 'quibbl-35bd2.appspot.com',
    messagingSenderId: '486037293179'
  }
};



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/environments/environment.ts